import { createContext, useContext } from 'react'

export interface Mixpanel {
    trackClickLink: (props: { component: string; to: string }) => void
    trackClickComponent: (props: Record<string, unknown> & { component: string }) => void
    trackSearchResource: (props: { component: string; search_keys: string[] }) => void
}

/* oxlint-disable no-empty-function */
const noopMixpanel: Mixpanel = {
    trackClickLink: () => {},
    trackClickComponent: () => {},
    trackSearchResource: () => {},
}
/* oxlint-enable no-empty-function */

const MixpanelContext = createContext<Mixpanel>(noopMixpanel)
export const MixpanelProvider = MixpanelContext.Provider
export const useMixpanel = () => useContext(MixpanelContext)
